import { OnboardingScreenAppUsers } from '../screens/AppUsers';
import { OnboardingScreenInterests } from '../screens/Interests';
import { OnboardingScreenSecurity } from '../screens/Security';

import { OnboardingReplikaAge } from './screens/Age';
import { OnboardingReplikaAiCharacteristic } from './screens/AiCharacteristic';
import { OnboardingReplikaChatExample } from './screens/ChatExample';
import { OnboardingReplikaChatVibe } from './screens/ChatVibe';
import { OnboardingReplikaDressUp } from './screens/DressUp';
import { OnboardingReplikaEmail } from './screens/Email';
import { OnboardingReplikaFamiliarity } from './screens/Familiarity';
import { OnboardingReplikaGender } from './screens/Gender';
import { OnboardingReplikaInteraction } from './screens/Interaction';
import { OnboardingReplikaLoneliness } from './screens/Loneliness';
import { OnboardingReplikaLonelinessGraph } from './screens/LonelinessGraph';
import { OnboardingReplikaName } from './screens/Name';
import { OnboardingReplikaNoLimits } from './screens/NoLimits';
import { OnboardingReplikaOutFit } from './screens/Outfit';
import { OnboardingReplikaPersonalizingFeed } from './screens/PersonalizingFeed';
import { OnboardingReplikaPreferences } from './screens/Preferences';
import { OnboardingReplikaRelationships } from './screens/Relationships';
import { OnboardingReplikaTopics } from './screens/Topics';
import { TOPICS_OPTIONS } from './screens/Topics/constants';
import { LayoutDataType } from './types';

export const laoutCategoriesSetupKeys: (
  | 'bbw'
  | 'girl'
  | 'old_women'
  | 'strong_stunning'
)[] = ['bbw', 'girl', 'old_women', 'strong_stunning'];

export const layoutSteps = {
  gender: {
    component: OnboardingReplikaGender,
    images: [],
  },
  age: {
    component: OnboardingReplikaAge,
    images: [],
  },
  familiarity: {
    component: OnboardingReplikaFamiliarity,
    images: [],
  },
  appusers: {
    component: OnboardingScreenAppUsers,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/AppUsers/planet_static.png',
    ],
  },
  security: {
    component: OnboardingScreenSecurity,
    images: [],
  },
  name: {
    component: OnboardingReplikaName,
    images: [],
  },
  topics: {
    component: OnboardingReplikaTopics,
    images: [],
  },
  chat_example: {
    component: OnboardingReplikaChatExample,
    images: TOPICS_OPTIONS.map(
      (topic) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/chat-by-topic/${topic.id}.png`,
    ),
  },
  preferences: {
    component: OnboardingReplikaPreferences,
    images: [],
  },
  no_limits: {
    component: OnboardingReplikaNoLimits,
    images: laoutCategoriesSetupKeys.map(
      (key) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${key}/no-limit.png`,
    ),
  },
  ai_characteristic: {
    component: OnboardingReplikaAiCharacteristic,
    images: [],
  },
  interests: {
    component: OnboardingScreenInterests,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/svg-sprite.svg',
    ],
  },
  chat_vibe: {
    component: OnboardingReplikaChatVibe,
    images: [],
  },
  interaction: {
    component: OnboardingReplikaInteraction,
    images: [],
  },
  relationships: {
    component: OnboardingReplikaRelationships,
    images: laoutCategoriesSetupKeys.map(
      (key) =>
        `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${key}/leveling.png`,
    ),
  },
  outfit: {
    component: OnboardingReplikaOutFit,
    images: [],
  },
  dress_up: {
    component: OnboardingReplikaDressUp,
    images: [
      ...laoutCategoriesSetupKeys.map(
        (key) =>
          `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${key}/outfit-casual.png`,
      ),
      ...laoutCategoriesSetupKeys.map(
        (key) =>
          `https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/${key}/outfit-hot.png`,
      ),
    ],
  },
  loneliness: {
    component: OnboardingReplikaLoneliness,
    images: [
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-dark.png',
      'https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/onboarding/loneliness/loneliness-graph-light.png',
    ],
  },
  loneliness_graph: {
    component: OnboardingReplikaLonelinessGraph,
    images: [],
  },
  personalizing_feed: {
    component: OnboardingReplikaPersonalizingFeed,
    images: [],
  },
  email: {
    component: OnboardingReplikaEmail,
    images: [],
  },
};

export const layoutStepsKeys = Object.keys(layoutSteps);

export const layoutDataDefault: LayoutDataType = {
  gender: null,
  age: '',
  name: '',
  email: '',
  ai_characteristic: 'Neutral',
  categories: [],
  characters: [],
  interests: [],
  preloadCategories: [],
  outfits: null,
  familiarity: null,
  interaction: null,
  loneliness: null,
  topics: null,
};

// Category constants - not used
// Categories are dynamically loaded from API via useQueryOnboardingCategories hook
// and sent to server on Preferences screen
export const HARDCODED_CATEGORIES = [];
